import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "circle",
  "use": "circle-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"circle\"><g transform=\"translate(0 -1028.362)\"><circle cx=\"12.1\" cy=\"1040.272\" r=\"10.509\" fill=\"#ebebeb\" /><circle cx=\"12\" cy=\"1040.362\" r=\"10.5\" fill=\"none\" stroke=\"currentColor\" stroke-dasharray=\"1.99829691 .99914846\" stroke-dashoffset=\".168\" stroke-width=\".999\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol